import { SelectedGymStorage } from 'src/app/storage/selected-gym.storage';
import { environment } from 'src/environments/environment';

export const OpenGymApiURL = (relativePath: string) => {
    const gymId = SelectedGymStorage.getSelectedGymId();

    return `${environment.apiURL}/open/gym/${gymId}${relativePath}`;
}